// extracted by mini-css-extract-plugin
export default {"container":"EntityChip_container__DSpJ8","icon":"EntityChip_icon__RKtu7","text":"EntityChip_text__h0Y2k","star":"EntityChip_star__1S5FT"};